import { defineStore } from "pinia";
import { ref } from "vue";

import type { GetUserQuery } from "@/sdk";

export const useUserStore = defineStore("userStore", () => {
	const userData = ref<null | GetUserQuery["user"][0]>(null);

	const setUserData = (newUserData: any) => {
		userData.value = newUserData;
	};

	const clearUserData = () => {
		userData.value = null;
	};

	return {
		userData,
		setUserData,
		clearUserData,
	};
});
